import { CoordinatesType, MarkerObjectType } from '../types/dataTypes';
import { getMarkerLabel } from '@/helpers';

const getStaticMapUrl = (
  lat: number,
  lng: number,
  size: string,
  apiKey: string,

  
  markers?:
    | { lat: number; lng: number; color?: string; label?: string }[]
    | null
): string => {
  if (markers) {
    let markerParams = markers
      .map((marker) => {
        const color = `color:black|`;
        const label = marker.label ? `label:${marker.label}|` : '';
        return `${color}${label}${marker.lat},${marker.lng}`;
      })
      .join('&markers=');

       markerParams += `&markers=color:0x357D42|${lat},${lng}`;

    return `https://maps.googleapis.com/maps/api/staticmap?size=${size}&markers=${markerParams}&style=feature:poi|element:all|visibility:off&key=${apiKey}`;
  }
  return `https://maps.googleapis.com/maps/api/staticmap?center=${lat},${lng}&zoom=17&size=${size}&style=feature:poi|element:all|visibility:off&key=${apiKey}`;
};

interface Props {
  coordinatesSetting?: CoordinatesType;
  zoomSetting?: number | null;
  markers?: MarkerObjectType[] | null;
  size?: string;
}

function StaticMapImg({ markers, coordinatesSetting, size="600x600" }:Props) {

  const mapMarkers = markers
    ? (markers
        .map((marker, index) => {
          if (marker.location.lat && marker.location.lng) {
            return {
              lat: marker.location.lat,
              lng: marker.location.lng,
              color: '0x357D42',
              label: `${getMarkerLabel(index)}`,
            };
          }
          return undefined;
        })
        .filter((marker) => marker !== undefined) as {
        lat: number;
        lng: number;
        color?: string;
        label?: string;
      }[])
    : null;

    if (coordinatesSetting?.lat && coordinatesSetting?.lng) {
      const lat = coordinatesSetting.lat;
      const lng = coordinatesSetting.lng;
      const apiKey = import.meta.env.VITE_API_GOOGLE_MAPS_API_KEY;

      const url = getStaticMapUrl(lat, lng, size, apiKey, mapMarkers);
     return url;
    }

};

export default StaticMapImg;
